const {
  ENVIRONMENT = 'development',
  REACT_APP_LOAN_SERVICE_URL: LOAN_SERVICE_URL = 'http://localhost:1045',
  REACT_APP_FILES_WEB_URL: FILES_WEB_URL = 'http://localhost:3001',
  REACT_APP_AUTH_SERVICE_URL: AUTH_SERVICE_URL = 'http://localhost:8080',
  REACT_APP_MICHMAN_CLIENT_ID: CLIENT_ID = ''
} = process.env

export { ENVIRONMENT, LOAN_SERVICE_URL, FILES_WEB_URL, AUTH_SERVICE_URL, CLIENT_ID }
